/**
 * Pick property from the `object` defined in `propertyMap`.
 * Handy for picking property_name as propertyName, i.e.
 * if you proved `myProp: 'my_prop'`, you will get `object.my_prop`
 * as `object.myProp`.
 */
export const pickProperties = (object, propertyMap) => {
  const result = {};
  Object.keys(propertyMap).forEach(key => {
    const alternateKey = propertyMap[key];
    if (object[key]) {
      result[key] = object[key];
    } else if (object[alternateKey]) {
      result[key] = object[alternateKey];
    }
  });
  return result;
};
